import script from "./mypet.vue?vue&type=script&setup=true&lang=js"
export * from "./mypet.vue?vue&type=script&setup=true&lang=js"

import "./mypet.vue?vue&type=style&index=0&id=41c46f58&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41c46f58"]])

export default __exports__